<div class="container mt-2">
  <div class="row">
    <div class="col-md-12">
      <div class="row mb-4 d-flex justify-content-end">
        <div class="col-md-4">
          <h1 uni-heading color="primary" alignText="center" class="mt-1">Perfiles Existentes</h1>
        </div>
        <div class="col-md-4">
          <div class="actions">
            <a
              (click)="addPerfil()"
              uni-button
              variant="info"
              icon="plus-circle"
              [iconReverse]="true"
              class="btn-slim float-md-right"
            >
              Nuevo Perfil
            </a>
          </div>
        </div>
      </div>
      <!-- <div class="row mb-3">
                <div class="col-md-4">
                    <table-actions [actionButtons]="actionButtons"
                                   (xClicked)="confirmDeletePerfil()"
                                   (editClicked)="editPerfil()"></table-actions>
                </div>

            </div> -->
    </div>
    <div class="col-md-12">
      <filter-table
        [columns]="columns"
        [searchCols]="searchCols"
        [data]="observablePerfiles"
        [selectableRow]="false"
        [selectedData]="selectedPerfiles"
        [excelName]="excelName"
      >
        <ng-template #actions let-row="row" let-value="value" ngx-datatable-cell-template>
          <button tooltip="Editar" uni-icon-button variant="info" (click)="editPerfil(row)">
            <uni-icon name="edit-2"></uni-icon>
          </button>
        </ng-template>
      </filter-table>
    </div>
  </div>
</div>
